// Ícones (traço estilo Lucide, os mesmos do Figma "Bee Do It — v2") e o logo da abelha.
import { useId, type SVGProps } from 'react';

const PATHS = {
  plus: 'M12 5v14M5 12h14',
  play: 'M7 4.5v15l12-7.5-12-7.5Z',
  pause: 'M8 5v14M16 5v14',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  clock: 'M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  timer: 'M10 2h4M12 14l3-3M20 14a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
  settings:
    'M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  shrink: 'M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7',
  expand: 'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7',
  alert: 'M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0ZM12 9v4M12 17h.01',
  calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
  chevronLeft: 'M15 18l-6-6 6-6',
  chevronRight: 'M9 18l6-6-6-6',
  chevronDown: 'M6 9l6 6 6-6',
  more: 'M12 12h.01M19 12h.01M5 12h.01',
  trash: 'M3 6h18M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2',
  edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4Z',
  x: 'M18 6 6 18M6 6l12 12',
  wifiOff: 'M12 20h.01M8.5 16.4a5 5 0 0 1 7 0M2 8.8a15 15 0 0 1 4.2-2.6M10.7 5.1A15 15 0 0 1 22 8.8M5 12.9a10 10 0 0 1 5.2-2.7M16.8 13.4A10 10 0 0 1 19 12.9M2 2l20 20',
  coffee: 'M17 8h1a4 4 0 1 1 0 8h-1M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4ZM6 2v2M10 2v2M14 2v2',
  skip: 'M5 4l10 8-10 8V4ZM19 5v14',
  logout: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  card: 'M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2ZM2 10h20',
  list: 'M11 5h10M11 12h10M11 19h10M3 5l1.5 1.5L7 4M3 12l1.5 1.5L7 11M3 19l1.5 1.5L7 18',
  mail: 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM22 6l-10 7L2 6',
  globe: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M6.3 17.7l-1.4 1.4M19.1 4.9l-1.4 1.4',
  moon: 'M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z',
  monitor: 'M3 4h18a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM8 21h8M12 17v4',
  external: 'M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6',
  lock: 'M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2ZM7 11V7a5 5 0 0 1 10 0v4',
  pip: 'M21 9V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M14 14h7v6h-7Z',
  fileText: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8ZM14 2v6h6M16 13H8M16 17H8M10 9H8',
  repeat: 'M17 2l4 4-4 4M3 11V9a3 3 0 0 1 3-3h15M7 22l-4-4 4-4M21 13v2a3 3 0 0 1-3 3H3',
} as const;

export type IconName = keyof typeof PATHS;

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  filled?: boolean;
}

export function Icon({ name, size = 16, filled = false, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

/** Logo: abelha sobre uma célula de favo com mel escorrendo (fonte: design/logo/gerar.mjs). */
export function BeeLogo({ size = 28 }: { size?: number }) {
  // ids únicos: o logo aparece mais de uma vez na mesma tela
  const id = `bee${useId().replace(/[^a-zA-Z0-9]/g, '')}`;
  const mel = `${id}-mel`;
  const body = `${id}-body`;
  const ink = '#1B1405';
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" fill="none" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id={mel} gradientUnits="userSpaceOnUse" cx="170" cy="110" r="440">
          <stop offset="0" stopColor="#FFDE7A" />
          <stop offset=".55" stopColor="#FFC83D" />
          <stop offset="1" stopColor="#FFA90F" />
        </radialGradient>
        <clipPath id={body}>
          <ellipse cx="256" cy="282" rx="90" ry="110" />
        </clipPath>
      </defs>
      <path d="M459 188.16Q482 228 459 267.84L392 383.88Q369 423.72 323 423.72L189 423.72Q143 423.72 120 383.88L53 267.84Q30 228 53 188.16L120 72.12Q143 32.28 189 32.28L323 32.28Q369 32.28 392 72.12Z" fill={`url(#${mel})`} />
      <path d="M280 423.72C296 423.72 304 427.72 312 435.72C316 440.72 320 444.72 325 444.72C330 444.72 332 442.22 336 442.22C339.5 442.22 341.8 445.22 342 449.72C336 455.72 332 461.72 332 469.72A18 18 0 0 0 368 469.72C368 461.72 364 455.72 359 449.72C360 431.72 386.7 393.32 396.7 376.02Z" fill={`url(#${mel})`} />
      <path d="M452 193.36Q472 228 452 262.64L384 380.42Q364 415.06 324 415.06L188 415.06Q148 415.06 128 380.42L60 262.64Q40 228 60 193.36L128 75.58Q148 40.94 188 40.94L324 40.94Q364 40.94 384 75.58Z" stroke="#fff" strokeOpacity=".28" strokeWidth="4" />
      <ellipse cx="343" cy="465.72" rx="4.5" ry="8" transform="rotate(20 343 465.72)" fill="#fff" fillOpacity=".55" />
      <g transform="translate(256 228) scale(.82) translate(-256 -254)">
        <path d="M238 180C234 152 226 132 214 118M274 180C278 152 286 132 298 118" stroke={ink} strokeWidth="15" strokeLinecap="round" />
        <circle cx="212" cy="115" r="15" fill={ink} />
        <circle cx="300" cy="115" r="15" fill={ink} />
        <ellipse cx="256" cy="282" rx="90" ry="110" fill={ink} />
        <g clipPath={`url(#${body})`} fill="#FFC83D">
          <rect x="160" y="250" width="192" height="28" />
          <rect x="160" y="308" width="192" height="28" />
        </g>
        <ellipse cx="256" cy="282" rx="90" ry="110" stroke={ink} strokeWidth="15" />
        <ellipse cx="236" cy="200" rx="22" ry="10" transform="rotate(-30 236 200)" fill="#fff" fillOpacity=".18" />
        <ellipse cx="180" cy="262" rx="70" ry="46" transform="rotate(-55 180 262)" fill="#fff" fillOpacity=".72" stroke={ink} strokeWidth="13" />
        <ellipse cx="332" cy="262" rx="70" ry="46" transform="rotate(55 332 262)" fill="#fff" fillOpacity=".72" stroke={ink} strokeWidth="13" />
      </g>
    </svg>
  );
}

export function GoogleLogo({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M22.6 12.2c0-.7-.1-1.4-.2-2H12v3.9h6a5.1 5.1 0 0 1-2.2 3.4v2.8h3.6c2.1-1.9 3.2-4.8 3.2-8.1Z" />
      <path fill="#34A853" d="M12 23c3 0 5.5-1 7.4-2.7l-3.6-2.8c-1 .7-2.3 1.1-3.8 1.1-2.9 0-5.4-2-6.3-4.6H2v2.9A11 11 0 0 0 12 23Z" />
      <path fill="#FBBC05" d="M5.7 14c-.2-.7-.4-1.4-.4-2s.1-1.4.4-2V7.1H2A11 11 0 0 0 1 12c0 1.8.4 3.4 1.2 4.9L5.7 14Z" />
      <path fill="#EA4335" d="M12 5.4c1.6 0 3.1.6 4.2 1.7l3.2-3.2A11 11 0 0 0 2 7.1L5.7 10c.9-2.6 3.4-4.6 6.3-4.6Z" />
    </svg>
  );
}

/** Logo da Microsoft: quatro quadrados (AC-089). */
export function MicrosoftLogo({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#F25022" d="M2 2h9.5v9.5H2Z" />
      <path fill="#7FBA00" d="M12.5 2H22v9.5h-9.5Z" />
      <path fill="#00A4EF" d="M2 12.5h9.5V22H2Z" />
      <path fill="#FFB900" d="M12.5 12.5H22V22h-9.5Z" />
    </svg>
  );
}
